:host {
  display: inline-flex;
  width: auto;
  background-color: var(--dark-blue-702-main-menu);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: calc(var(--spacer) / 2) calc(1.5 * var(--spacer));
  overflow: hidden;
  align-items: center;
}

gz-tooltip:not(:last-of-type) {
  margin-right: 2px;
}

.menu-item-button {
  border: transparent;
  background-color: transparent;
  color: var(--white-layout-300-primary);
  position: relative;
  width: calc(3 * var(--spacer));
  height: calc(3 * var(--spacer));
  transition: background-color 0.3s ease 0s, color 0.3s ease 0s;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: var(--white-layout-010-hover-primary);
    color: var(--white-layout-250-disabled-text-on-blue-background);
  }

  &.active {
    color: var(--blue-layout-301-active);
  }

  &:focus-visible {
    outline: 2px solid var(--blue-layout-504-focus-on-dark-background-light-theme) !important;
    background-color: var(--blue-layout-305-active);
    border-radius: 4px;
  }
}

.menu-item-icon {
  line-height: 1;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge {
  position: absolute;
  width: calc(2 * var(--spacer));
  height: calc(2 * var(--spacer));
  border-radius: 50%;
  background-color: var(--red-layout-001-logo);
  color: var(--white-layout-300-primary);
  font-size: 9px;
  line-height: 15px;
  font-family: var(--font-family-secondary);
  top: 0;
  right: calc(var(--spacer) / -2);
}
